export const CHATBOT_PANEL_MIN_WIDTH = 350;
export const CHATBOT_PANEL_MAX_WIDTH = 800;
export const CHATBOT_PANEL_DEFAULT_WIDTH = 400;
export const CHATBOT_PANEL_HORIZONTAL_PADDING = 6;
// Width to subtract to keep the page underneath visible when the panel is constrained by the viewport.
export const CHATBOT_PANEL_WIDE_SCREEN_MARGIN = 48;

export const CHATBOT_PANEL_WIDTH_CSS_VAR = '--chatbot-panel-width';

export const clampChatbotPanelWidth = width =>
  Math.min(CHATBOT_PANEL_MAX_WIDTH, Math.max(CHATBOT_PANEL_MIN_WIDTH, width));

// Shrinks the configured width to fit a viewport that is narrower than it, so the panel never
// overflows the window. Returns the configured width untouched once the viewport is wide enough
// again, which is what restores the user's chosen width after the window is widened back out.
export const fitChatbotPanelWidthToViewport = (configuredWidth, viewportWidth) => {
  // The viewport width is 0 until the resize listener in useViewSizes.js reports it for the first time.
  if (!viewportWidth) {
    return configuredWidth;
  }

  return Math.min(configuredWidth, viewportWidth - CHATBOT_PANEL_WIDE_SCREEN_MARGIN);
};

export const syncChatbotLayoutState = ({
  isOpen,
  isDesktop,
  width = CHATBOT_PANEL_DEFAULT_WIDTH,
}) => {
  if (typeof document === 'undefined') {
    return null;
  }

  if (isOpen && isDesktop) {
    const paddingAndBorder = 8;
    document.documentElement.style.setProperty(
      CHATBOT_PANEL_WIDTH_CSS_VAR,
      `${width + paddingAndBorder}px`
    );
  } else {
    document.documentElement.style.setProperty(CHATBOT_PANEL_WIDTH_CSS_VAR, 0);
  }
};

export const clearChatbotLayoutState = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  document.documentElement.style.removeProperty(CHATBOT_PANEL_WIDTH_CSS_VAR);
};
